
import { InsurancePolicy } from '@/core/types/orders.types'
import { defineComponent, PropType, reactive } from 'vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import { useFile } from '@/common/composable/useFile'
import { orders } from '@/core/realisations/orders.realisation'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: { TheButton },
    props: {
        insurancePolicies: {
            type: Array as PropType<InsurancePolicy[]>,
            default: () => [],
        },
    },
    setup() {
        const { saveFile } = useFile()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const formatDate = (date: string) => {
            if (date) {
                return date.split('T')[0].split('-').reverse().join('.')
            }

            return '-'
        }

        const download = async (item: InsurancePolicy) => {
            try {
                state.is_loading = true

                const response = await orders.downloadInsurance(item.fileUuid)
                saveFile(response, `Страховой_полис_№${item.id}`)
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: `Ошибка при скачивании`,
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            formatAmount,
            formatDate,
            download,
        }
    },
})
